import CIMSTable from 'components/CIMSTable'
import { useAuthContext } from 'context/AuthContext'
import { useProjectContext } from 'context/ProjectContext'
import { usePermissionsContext } from '../../PermissionsContext'
import AddUsersModal from './components/AddUsersModal'
import { useBulkActions } from './hooks/useBulkActions'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useCustom } from './hooks/useCustom'
import { useEdit } from './hooks/useEdit'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

function PermissionsTable() {
  const {
    fetching,
    records,
    refetch,
    selection: { rowKeys, setRowKeys },
  } = usePermissionsContext()
  const { projectId } = useProjectContext()
  const { user } = useAuthContext()
  const isAdmin = !!user?.admin(projectId).authorized

  return (
    <CIMSTable
      rowKey="id"
      loading={fetching}
      records={records}
      details={'Only project admins can edit workflow permissions'}
      rowSelection={
        isAdmin
          ? {
              selectedRowKeys: rowKeys,
              onChange: setRowKeys,
              getCheckboxProps: ({ deleted }) => ({ disabled: deleted }),
            }
          : undefined
      }
      columns={useColumns()}
      actions={{
        header: {
          onReload: refetch,
          create: useCreate(),
          custom: useBulkActions(),
        },
        row: {
          edit: useEdit(),
          custom: useCustom(),
          remove: useRemove(),
          restore: useRestore(),
        },
      }}
    >
      <AddUsersModal />
    </CIMSTable>
  )
}

export default PermissionsTable
